import { Construction } from "lucide-react";
import { Navigate, useParams } from "react-router-dom";
import { Empty } from "../components/ui";
import type { Me } from "../lib/api";

/** /apps/<appId>/…: each app mounts here once it's built (Job Automation from phase 2). */
export default function AppPlaceholder({ me }: { me: Me }) {
  const { appId } = useParams();
  const app = me.apps?.find((a) => a.id === appId);
  if (!app) return <Navigate to="/" replace />;
  return (
    <Empty icon={<Construction className="size-8" />} title={app.name}>
      This app isn't available in the portal yet.
    </Empty>
  );
}
